/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1Object
 */
export interface ApiResponse1Object {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1Object
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1Object
     */
    message?: string | null;
    /**
     * Response data'sı
     * @type {any}
     * @memberof ApiResponse1Object
     */
    data?: any | null;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1Object
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1Object interface.
 */
export function instanceOfApiResponse1Object(value: object): value is ApiResponse1Object {
    return true;
}

export function ApiResponse1ObjectFromJSON(json: any): ApiResponse1Object {
    return ApiResponse1ObjectFromJSONTyped(json, false);
}

export function ApiResponse1ObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1Object {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1ObjectToJSON(json: any): ApiResponse1Object {
    return ApiResponse1ObjectToJSONTyped(json, false);
}

export function ApiResponse1ObjectToJSONTyped(value?: ApiResponse1Object | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': value['data'],
        'errors': value['errors'],
    };
}

